import { PickUpParcelCodeDto, PickUpParcelCodeModel } from '../types/pick-up-parcel-code'

export const transformPickUpParcelCode = (
  response: PickUpParcelCodeDto,
): PickUpParcelCodeModel => ({
  imageUrl: response.image_url,
  code: response.code,
})
